import type { DropDownProps } from 'antd/es/dropdown'
import { useEmotionCss } from '@ant-design/use-emotion-css'
import { Dropdown } from 'antd'
import { clsx } from 'clsx'
import * as React from 'react'

export type HeaderDropdownProps = {
  overlayClassName?: string
  placement?: 'top' | 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topCenter' | 'topRight' | 'bottomCenter'
} & Omit<DropDownProps, 'overlay'>

const HeaderDropdown: React.FC<HeaderDropdownProps> = ({ overlayClassName: cls, ...restProps }) => {
  const className = useEmotionCss(({ token }) => {
    return {
      [`@media screen and (max-width: ${token.screenXS})px`]: {
        width: '100%'
      }
    }
  })
  return <Dropdown classNames={{ root: clsx(className, cls) }} {...restProps} />
}

export default HeaderDropdown
